<template>
    <div class="main landing">
        <header>
            <div class="logo-wraper">
                <div class="logo">
                    <img src="@/assets/images/icons/post-office-white.svg"/>
                </div>
                <div class="v-line"></div>
                <div class="logo">
                    <img src="@/assets/images/icons/compitacenter.svg"/>
                </div>
            </div>

        </header>
        <section class="hero-section">
            <img src="/images/hero-po.jpg"/>
        </section>
        <section class="welcom_section">
            <div class="container">

                <div class="small-title">THE POST OFFICE</div>
                <div class="title"> WELCOME TO THE FUTURE</div>
                <div class="sub-title"> REINVENTED <span>FOR YOU.</span></div>
                <div class="description">
                    We understand the Post Office has a clearly defined strategy for “strands to future success”.<br>
                    This success is underpinned by seven pillars. We have symbolised these through icons which are accredited to future technology deployed across Post Office that aligns with, and delivers on your future strategy.
                </div>

                <div class="icon-list">
                    <div class="icons col"
                         v-for="service in elStrategic"
                         :key="service.id"
                    >
                        <img :src="service.icon"/>

                        <span>{{service.name}}</span>
                    </div>
                </div>

            </div>
        </section>
        <section class="environments">
            <div class="container">

                <div class="environment"
                    v-for="item in elEnv"
                     :key="item.id"
                >
                    <hr>
                    <div class="title"
                         v-html="item.title + ' POST OFFICE'"
                    ></div>
                    <div class="image">
                        <div class="link"
                             v-on:click="setActiveEnv(item.id)"
                        >ENTER ENVIRONMENT</div>
                        <img :src="item.image">
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    import store from '@/store'
    // import HeroSection from '@/components/landing/HeroSection.vue'
    // import HeroSection2 from '@/components/landing/HeroSection2.vue'
    // import EnvHomeSection from '@/components/landing/EnvHomeSection.vue'

    export default {
        name: 'Landing',
        props: ['selectEnvironments', 'envListImages'],
        data() {
            return {
                // elEnv: store.state.environments,
                strategies: [
                    '/images/icons/PostOffice_branchtech.png',
                    '/images/icons/PostOffice_cash.png',
                    '/images/icons/PostOffice_innovation.png',
                    '/images/icons/PostOffice_network.png',
                    '/images/icons/PostOffice_partnerships.png',
                    '/images/icons/PostOffice_relationships.png',
                    '/images/icons/PostOffice_value.png'
                ]
            }
        },
        computed: {
            elEnv() {
                return store.state.environments;
            },
            elStrategic() {
                return store.state.strategic;
            }
        },
        mounted() {
        },
        components: {
            // HeroSection, HeroSection2, EnvHomeSection
        },
        methods: {
            setActiveEnv(id) {
                this.$emit('setActiveEnv', id)
                this.$router.push({name: 'Environments'});
            },

            addEnv(id) {
                this.$emit('addEnv', id)
            },
            removeEnv(id) {
                this.$emit('removeEnv', id)
            },
        }

    }
</script>
